import { createSlice } from "@reduxjs/toolkit";
import { ICollegeSlice } from "../../../models/master/college";


const initialCollegeState: ICollegeSlice = {
  colleges:undefined,
  college:undefined
};

const collegeSlice = createSlice({
  name: "college",
  initialState: initialCollegeState,
  reducers: {
    setColleges: (state, action: { payload: any }) => {
      state.colleges = action.payload;
    },
    setCollege: (state, action: { payload: any }) => {
      state.college = action.payload;
    },
    
  },
});

export const { setColleges, setCollege } =
  collegeSlice.actions;

const collegeReducer = collegeSlice.reducer;

export type collegeState = ReturnType<typeof collegeReducer>;

export default collegeReducer;
